import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  // Clave secreta para encriptación
  // IMPORTANTE: Esta clave está en el código del cliente, pero hace MUY difícil
  // la manipulación. Para seguridad total, el backend siempre valida los precios.
  private readonly SECRET_KEY = 'BuhoEcommerce2024!SecureCart#Key@XYZ789';

  constructor() {}

  /**
   * Encripta datos usando AES-256
   * @param data Objeto a encriptar
   * @returns String encriptado
   */
  encrypt(data: any): string {
    try {
      const jsonString = JSON.stringify(data);
      const encrypted = CryptoJS.AES.encrypt(jsonString, this.SECRET_KEY);
      return encrypted.toString();
    } catch (error) {
      console.error('Error al encriptar:', error);
      return null;
    }
  }

  /**
   * Desencripta datos
   * @param encryptedData String encriptado
   * @returns Objeto desencriptado o null si hay error
   */
  decrypt(encryptedData: string): any {
    try {
      const decrypted = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
      const jsonString = decrypted.toString(CryptoJS.enc.Utf8);

      if (!jsonString) {
        return null;
      }

      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Error al desencriptar:', error);
      return null;
    }
  }

  /**
   * Genera un checksum SHA-256 para detectar manipulación
   * @param data Objeto para generar checksum
   * @returns Hash SHA-256
   */
  generateChecksum(data: any): string {
    try {
      const jsonString = JSON.stringify(data);
      // Concatenar con la clave secreta para mayor seguridad
      return CryptoJS.SHA256(jsonString + this.SECRET_KEY).toString();
    } catch (error) {
      console.error('Error al generar checksum:', error);
      return null;
    }
  }

  /**
   * Verifica si el checksum es válido
   * @param data Objeto a verificar
   * @param checksum Checksum a comparar
   * @returns true si el checksum es válido
   */
  verifyChecksum(data: any, checksum: string): boolean {
    const calculatedChecksum = this.generateChecksum(data);
    return calculatedChecksum === checksum;
  }

  /**
   * Genera un hash simple (para IDs de sesión, etc)
   */
  generateHash(input: string): string {
    return CryptoJS.SHA256(input).toString();
  }
}
